import React from 'react';
import './subscription.scss';
import { connect } from 'react-redux';
import SlotPicker from '../../common/Subscription/SlotPicker';
import WeekView from '../../common/Subscription/WeekView';
import SecondaryNav from '../SecondaryNav/SecondaryNav';
import SubscriptionItems from '../../common/Subscription/SubscriptionItems';
import Button from '../../common/Button/Button';
import history from 'hb-redux-store/history';
import { getCalendar } from 'hb-redux-store/feature/subscription/subscription.action';
import Loader from '../Skeletons/Loader/Loader';
import { setAppNotification } from 'hb-redux-store/initial.action';
import Icon from '../Icon/Icon';
import ProductMarque from '../../common/Subscription/ProductMarque';

class RamadanSubscription extends React.Component {
  componentDidMount() {
    this.props.getCalendar();
    // this.slotScrolled = false;
  }

  // setScrollSlot() {
  //   const selectedElement = document.querySelector(
  //     '.subsc--slots--slot.selected'
  //   );
  //   if (selectedElement) {
  //     const offsetLeft = selectedElement.offsetLeft;
  //     // console.log('offsetLeft: ', offsetLeft);
  //     const scrollWidth = offsetLeft > 50 ? offsetLeft - 50 : 10;
  //     // console.log('scrollWidth: ', scrollWidth);
  //     const scrollElement = document.querySelector('.subsc--slots');
  //     // console.log('scrollElement: ', scrollElement);
  //     scrollElement &&
  //       scrollElement.scroll &&
  //       scrollElement.scroll({ left: scrollWidth, behavior: 'smooth' });
  //     this.slotScrolled = true;
  //   }
  // }

  render() {
    const { loading, calendar, launchInfo } = this.props;
    const { finalPrice = 0, strikedPrice = 0 } = calendar || {};
    const isLoggedInUser = launchInfo.loggedIn;
    // if (calendar && !loading && !this.slotScrolled) {
    //   setTimeout(() => this.setScrollSlot(), 50);
    // }
    return (
      <div className="subsc">
        <SecondaryNav
          showCart={false}
          showSearch={false}
          title=""
          capitalize
          transparent
        />
        <div className="subsc--banner-container">
          <div className="subsc--banner">
            <img
              src="https://ik.imagekit.io/iwcam3r8ka/prod/subscription/202104/e7ce4fc9-39e9-417d-bbc9-0a70b68fed3d.png"
              alt="Ramadan Special"
            />
          </div>
          <ProductMarque />
        </div>
        {loading && <Loader />}
        {calendar && (
          <React.Fragment>
            <SlotPicker />
            <WeekView />
            <SubscriptionItems />
            <div className="subsc--summary-unit justify-content--space-between">
              <div className="subsc--summary-unit--pricing">
                <Icon class="icon-subscription-cart" size={20} />
                {strikedPrice < finalPrice && (
                  <span className="striked">{`₹${strikedPrice}`}</span>
                )}
                <span className="final">{`₹${finalPrice}`}</span>
              </div>
              <div className="">
                <Button
                  type="submit"
                  className="button button-secondary"
                  onClick={() => {
                    const { selectedSlot } = this.props;
                    if (!isLoggedInUser) {
                      return history.push(
                        '/login?redirectUrl=ramadan-subscription'
                      );
                      // return this.props.setAppNotification(
                      //   'Please login to subscribe.'
                      // );
                    }
                    if (calendar.subscriptionId) {
                      if (!selectedSlot) {
                        return this.props.setAppNotification(
                          'Please choose delivery slot.'
                        );
                      }
                      if (!finalPrice > 0) {
                        return this.props.setAppNotification(
                          'Please selected products for atleast one day.'
                        );
                      }
                      history.push(
                        `/subscription-summary/${calendar.subscriptionId}`
                      );
                    }
                  }}
                  disabled={loading}
                >
                  {isLoggedInUser ? 'View Summary' : 'Login To Subscribe'}
                </Button>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ subscriptionReducer, initialReducer }) => ({
  loading: subscriptionReducer.loading,
  calendar: subscriptionReducer.calendar,
  selectedSlot: subscriptionReducer.selectedSlot,
  subscriptionItems: subscriptionReducer.subscriptionItems,
  launchInfo: initialReducer.launchInfo,
});

const mapDispatchToProps = {
  getCalendar,
  setAppNotification,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RamadanSubscription);
